const getCookies = ctx => {
  if (typeof window === 'undefined') {
    return ctx.ctx.req.cookies;
  }
  const cookies = document.cookie.split(';');
  return cookies.reduce((prev, cookie) => {
    const index = cookie.indexOf('=');
    const key = cookie.slice(0, index);
    const value = cookie.slice(index);
    return { ...prev, [key]: value };
  }, {});
};

export default getCookies;
